/**
 * Blog Controls - Search, Filters Dropdown, and Per Page
 * TCG Collection Theme - Modern Design
 */

// Store references to close functions
const dropdownClosers = {};

document.addEventListener('DOMContentLoaded', function() {
  initBlogSearch();
  initFiltersDropdown();
  initPerPageSelector();
});

// Close all dropdowns except the specified one
function closeOtherDropdowns(exceptKey) {
  Object.keys(dropdownClosers).forEach(key => {
    if (key !== exceptKey && dropdownClosers[key]) {
      dropdownClosers[key]();
    }
  });
}

/**
 * Initialize search functionality
 */
function initBlogSearch() {
  const searchInput = document.getElementById('blog-search-input');
  const articlesContainer = document.querySelector('.blog-articles');

  if (!searchInput || !articlesContainer) return;

  const articleCards = articlesContainer.querySelectorAll('.blog-articles__article');
  if (articleCards.length === 0) return;

  let debounceTimer;

  // Search input handler with debounce
  searchInput.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      performSearch(this.value, articleCards, articlesContainer);
    }, 150);
  });

  // Escape key clears search
  searchInput.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && this.value) {
      this.value = '';
      performSearch('', articleCards, articlesContainer);
      this.blur();
    }
  });
}

/**
 * Filter articles based on search query
 */
function performSearch(query, articleCards, container) {
  const searchTerm = query.toLowerCase().trim();
  let visibleCount = 0;

  articleCards.forEach(card => {
    const title = card.querySelector('.card__heading')?.textContent?.toLowerCase() || '';
    const excerpt = card.querySelector('.article-card__excerpt')?.textContent?.toLowerCase() || '';

    const matches = searchTerm === '' || title.includes(searchTerm) || excerpt.includes(searchTerm);

    card.style.display = matches ? '' : 'none';
    if (matches) visibleCount++;
  });

  toggleNoResults(container, visibleCount === 0 && searchTerm !== '');
}

/**
 * Show/hide no results message
 */
function toggleNoResults(container, show) {
  const existingMessage = container.querySelector('.blog-no-results');

  if (show && !existingMessage) {
    const noResults = document.createElement('div');
    noResults.className = 'blog-no-results';
    noResults.innerHTML = `
      <svg viewBox="0 0 24 24" width="48" height="48" style="opacity: 0.5; margin-bottom: 1rem;">
        <path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
      </svg>
      <p>No se encontraron artículos</p>
      <p style="font-size: 0.9rem; opacity: 0.7;">Prueba con otros términos de búsqueda</p>
    `;
    container.appendChild(noResults);
  } else if (!show && existingMessage) {
    existingMessage.remove();
  }
}

/**
 * Initialize filters dropdown menu
 */
function initFiltersDropdown() {
  const toggleButton = document.getElementById('blog-filters-toggle');
  const menu = document.getElementById('blog-filters-menu');
  const dropdown = document.querySelector('.blog-filters-dropdown');

  if (!toggleButton || !menu) return;

  let scrollPosition = 0;

  // Register close function
  dropdownClosers['filters'] = () => toggleFiltersMenu(false);

  // Toggle menu on button click
  toggleButton.addEventListener('click', function(e) {
    e.stopPropagation();
    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    if (!isExpanded) {
      closeOtherDropdowns('filters');
    }
    toggleFiltersMenu(!isExpanded);
  });

  // Close menu when clicking outside
  document.addEventListener('click', function(e) {
    if (!menu.contains(e.target) && !toggleButton.contains(e.target)) {
      toggleFiltersMenu(false);
    }
  });

  // Close menu on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      toggleFiltersMenu(false);
    }
  });

  function toggleFiltersMenu(open) {
    toggleButton.setAttribute('aria-expanded', open);
    menu.hidden = !open;

    if (open) {
      toggleButton.classList.add('blog-filters__toggle--active');
      if (dropdown) dropdown.classList.add('is-open');

      // Block body scroll on mobile
      if (window.innerWidth < 750) {
        scrollPosition = window.pageYOffset;
        document.body.classList.add('filters-menu-open');
        document.body.style.top = `-${scrollPosition}px`;
      }
    } else {
      toggleButton.classList.remove('blog-filters__toggle--active');
      if (dropdown) dropdown.classList.remove('is-open');

      // Restore body scroll
      if (document.body.classList.contains('filters-menu-open')) {
        document.body.classList.remove('filters-menu-open');
        document.body.style.top = '';
        window.scrollTo(0, scrollPosition);
      }
    }
  }
}

/**
 * Initialize per page dropdown with client-side pagination
 */
function initPerPageSelector() {
  const toggleButton = document.getElementById('blog-per-page-toggle');
  const menu = document.getElementById('blog-per-page-menu');
  const articlesContainer = document.querySelector('.blog-articles');
  const mainBlog = document.querySelector('.main-blog');

  if (!toggleButton || !menu || !articlesContainer) return;

  const STORAGE_KEY = 'blog_per_page';
  const PAGE_KEY = 'blog_current_page';
  const DEFAULT_PER_PAGE = 6;
  const VALID_VALUES = [6, 9, 12];

  let currentPage = 1;
  let perPage = DEFAULT_PER_PAGE;
  const allArticles = Array.from(articlesContainer.querySelectorAll('.blog-articles__article'));
  const totalArticles = allArticles.length;

  // Get current per_page from URL or localStorage
  function getCurrentPerPage() {
    const urlParams = new URLSearchParams(window.location.search);
    const urlValue = parseInt(urlParams.get('per_page'), 10);

    if (VALID_VALUES.includes(urlValue)) {
      localStorage.setItem(STORAGE_KEY, urlValue);
      return urlValue;
    }

    const storedValue = parseInt(localStorage.getItem(STORAGE_KEY), 10);
    if (VALID_VALUES.includes(storedValue)) {
      return storedValue;
    }

    return DEFAULT_PER_PAGE;
  }

  // Get current page from URL
  function getCurrentPage() {
    const urlParams = new URLSearchParams(window.location.search);
    const pageValue = parseInt(urlParams.get('page'), 10);
    return pageValue > 0 ? pageValue : 1;
  }

  // Calculate total pages
  function getTotalPages() {
    return Math.ceil(totalArticles / perPage);
  }

  // Apply pagination - show only articles for current page
  function applyPagination() {
    const totalPages = getTotalPages();
    const startIndex = (currentPage - 1) * perPage;
    const endIndex = startIndex + perPage;

    allArticles.forEach((article, index) => {
      article.style.display = (index >= startIndex && index < endIndex) ? '' : 'none';
    });

    updatePaginationUI(totalPages);
    updatePerPageButton();
    updateURL();
  }

  // Update button text
  function updatePerPageButton() {
    const buttonText = toggleButton.querySelector('span');
    if (buttonText) {
      buttonText.textContent = `${perPage} / pág`;
    }

    // Update active state in menu
    menu.querySelectorAll('.blog-per-page-item').forEach(item => {
      const itemValue = parseInt(item.dataset.value, 10);
      const isActive = itemValue === perPage;
      item.classList.toggle('blog-per-page-item--active', isActive);

      const existingCheck = item.querySelector('svg');
      if (isActive && !existingCheck) {
        const checkSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        checkSvg.setAttribute('viewBox', '0 0 24 24');
        checkSvg.setAttribute('width', '14');
        checkSvg.setAttribute('height', '14');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('fill', 'currentColor');
        path.setAttribute('d', 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z');
        checkSvg.appendChild(path);
        item.appendChild(checkSvg);
      } else if (!isActive && existingCheck) {
        existingCheck.remove();
      }
    });
  }

  // Create or update pagination UI
  function updatePaginationUI(totalPages) {
    let paginationContainer = document.querySelector('.blog-pagination-js');

    if (totalPages <= 1) {
      if (paginationContainer) paginationContainer.remove();
      return;
    }

    if (!paginationContainer) {
      paginationContainer = document.createElement('div');
      paginationContainer.className = 'blog-pagination-js pagination-wrapper';
      articlesContainer.parentNode.insertBefore(paginationContainer, articlesContainer.nextSibling);
    }

    paginationContainer.innerHTML = createPaginationHTML(totalPages);
    attachPaginationListeners(paginationContainer, totalPages);
  }

  // Create pagination HTML
  function createPaginationHTML(totalPages) {
    let html = '<nav class="pagination" role="navigation" aria-label="Paginación">';
    html += '<ul class="pagination__list list-unstyled">';

    // Previous button
    if (currentPage > 1) {
      html += `<li><a href="#" class="pagination__item pagination__item--prev" data-page="${currentPage - 1}" aria-label="Página anterior">
        <svg aria-hidden="true" focusable="false" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>
      </a></li>`;
    }

    // Page numbers
    for (let i = 1; i <= totalPages; i++) {
      if (i === currentPage) {
        html += `<li><span class="pagination__item pagination__item--current" aria-current="page">${i}</span></li>`;
      } else {
        html += `<li><a href="#" class="pagination__item" data-page="${i}">${i}</a></li>`;
      }
    }

    // Next button
    if (currentPage < totalPages) {
      html += `<li><a href="#" class="pagination__item pagination__item--next" data-page="${currentPage + 1}" aria-label="Página siguiente">
        <svg aria-hidden="true" focusable="false" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>
      </a></li>`;
    }

    html += '</ul></nav>';
    return html;
  }

  // Attach click listeners to pagination
  function attachPaginationListeners(container, totalPages) {
    container.querySelectorAll('a[data-page]').forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const newPage = parseInt(this.dataset.page, 10);
        if (newPage >= 1 && newPage <= totalPages) {
          // Add animation class
          this.classList.add('pagination-clicked');

          // Wait for animation then change page
          setTimeout(() => {
            currentPage = newPage;
            applyPagination();
            // Scroll to top of articles
            articlesContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 200);
        }
      });
    });
  }

  // Update URL without reload
  function updateURL() {
    const url = new URL(window.location.href);

    if (perPage === DEFAULT_PER_PAGE) {
      url.searchParams.delete('per_page');
    } else {
      url.searchParams.set('per_page', perPage.toString());
    }

    if (currentPage === 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', currentPage.toString());
    }

    window.history.replaceState({}, '', url.toString());
    localStorage.setItem(STORAGE_KEY, perPage);
  }

  // Initialize
  perPage = getCurrentPerPage();
  currentPage = getCurrentPage();
  const totalPages = getTotalPages();
  if (currentPage > totalPages) currentPage = 1;
  applyPagination();

  // Register close function
  dropdownClosers['perPage'] = () => togglePerPageMenu(false);

  // Toggle menu on button click
  toggleButton.addEventListener('click', function(e) {
    e.stopPropagation();
    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    if (!isExpanded) {
      closeOtherDropdowns('perPage');
    }
    togglePerPageMenu(!isExpanded);
  });

  // Close menu when clicking outside
  document.addEventListener('click', function(e) {
    if (!menu.contains(e.target) && !toggleButton.contains(e.target)) {
      togglePerPageMenu(false);
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      togglePerPageMenu(false);
    }
  });

  // Handle per-page item clicks
  menu.querySelectorAll('.blog-per-page-item').forEach(item => {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      const value = parseInt(this.dataset.value, 10);

      if (VALID_VALUES.includes(value)) {
        perPage = value;
        currentPage = 1; // Reset to page 1 when changing per_page
        applyPagination();
        togglePerPageMenu(false);
      }
    });
  });

  function togglePerPageMenu(open) {
    toggleButton.setAttribute('aria-expanded', open);
    menu.hidden = !open;
  }
}
